// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"0f3813ee","488":"94140801"}[chunkId] + ".chunk.js";
};